export default "__VITE_ASSET__DWAxTG_1__"